module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "name": _vm.name,
      "label": "name",
      "options": _vm.getOptions,
      "placeholder": _vm.t('Select'),
      "multiple": _vm.isMultiple,
      "clear-on-select": _vm.getClearOnSelect,
      "close-on-select": _vm.getCloseOnSelect
    },
    model: {
      value: (_vm.proxyValue),
      callback: function($$v) {
        _vm.proxyValue = $$v
      },
      expression: "proxyValue"
    }
  }), _vm._v(" "), (_vm.isErrors) ? _c('ul', {
    staticClass: "error-placeholder"
  }, _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-650457e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/SelectInput.vue
// module id = 1310
// module chunks = 2